import React from "react";
import ComingSoonCard from "./ComingSoonCard";

const UPCOMING = [
  {
    testId: "upcoming-derniers-jours",
    bgImage: "/assets/derniers-jours-sur-terre.jpeg",
    titleText: "Derniers Jours Sur Terre",
    tagline: "Série originale Kinebe TV",
    ageRating: "-18",
    badges: ["Série originale", "4K Ultra HD", "HDR10", "Dolby Atmos", "5.1 Surround"],
    description:
      "La série originale signée Kinebe TV. Un thriller post-apocalyptique en plusieurs épisodes où chaque minute compte. Le compte à rebours commence ici.",
  },
  {
    testId: "upcoming-never-hike-alone",
    bgImage: "/assets/never-hike-alone-bg.jpg",
    titleImage: "/assets/never-hike-alone-logo.png",
    titleText: "Never Hike Alone",
    tagline: "Fanfilm · Vendredi 13",
    ageRating: "-18",
    badges: ["Fanfilm", "4K Ultra HD", "HDR10", "Dolby Atmos", "VF · VO"],
    description:
      "Un fanfilm hommage à la saga Vendredi 13. Un randonneur solitaire s'aventure dans les forêts entourant Crystal Lake, sans se douter que la légende de Jason Voorhees est bien plus qu'un mythe.",
  },
  {
    testId: "upcoming-never-hike-in-snow",
    bgImage: "/assets/never-hike-in-snow-bg.jpg",
    titleImage: "/assets/never-hike-in-snow-logo.png",
    titleText: "Never Hike In The Snow",
    tagline: "Fanfilm · Vendredi 13",
    ageRating: "-18",
    badges: ["Fanfilm", "4K Ultra HD", "HDR10", "Dolby Atmos", "VF · VO"],
    description:
      "La suite glaciale du fanfilm culte. Pendant un hiver sans fin aux abords de Crystal Lake, un ancien ranger traque Jason Voorhees dans la neige. Le sang contraste cette fois sur la glace.",
  },
  {
    testId: "upcoming-driller-killer",
    bgImage: "/assets/driller-killer-bg.jpg",
    titleImage: "/assets/driller-killer-logo.png",
    titleText: "Driller Killer",
    tagline: "Film libre · Classique restauré · 1979",
    ageRating: "-18",
    badges: ["Film libre", "4K Ultra HD", "HDR", "Dolby Atmos", "Uncut"],
    description:
      "Le film culte underground d'Abel Ferrara (1979) restauré en 4K. New York en déliquescence, un peintre torturé sombre dans la folie, et sa perceuse électrique devient l'instrument d'une purge sanglante. Un pilier des video nasties, aujourd'hui libre de droits.",
  },
  {
    testId: "upcoming-night-living-dead",
    bgImage: "/assets/night-living-dead-bg.jpg",
    titleImage: "/assets/night-living-dead-logo.png",
    titleText: "Night of the Living Dead",
    tagline: "Film libre · Chef-d'œuvre restauré · 1968",
    ageRating: "-16",
    badges: ["Film libre", "4K Ultra HD", "HDR", "Dolby Atmos", "Restauration 4K"],
    description:
      "Le premier film de George A. Romero (1968). Une poignée de survivants barricadés dans une ferme de Pennsylvanie affronte la toute première nuit où les morts reviennent à la vie. Film fondateur du cinéma de zombies, tombé dans le domaine public, restauré ici en 4K Ultra HD.",
  },
];

export default function UpcomingRow() {
  return (
    <section data-testid="upcoming-row" className="space-y-4">
      <div className="px-4 sm:px-8 lg:px-12">
        <div className="font-mono-mini text-[11px] uppercase tracking-[0.4em] text-[color:var(--ns-accent)]">
          Prochainement · Fanfilms & Productions originales
        </div>
        <h2 className="font-display text-2xl sm:text-3xl text-white uppercase tracking-tight">
          À l&apos;affiche très bientôt
        </h2>
      </div>

      <div className="px-4 sm:px-8 lg:px-12 pt-2 pb-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5 gap-5 sm:gap-6">
        {UPCOMING.map((item) => (
          <ComingSoonCard key={item.testId} {...item} />
        ))}
      </div>
    </section>
  );
}
